import { useTranslation } from "react-i18next";
import {
  Avatar,
  ComplexListItem,
  DashboardWidget,
  Elective,
  formatDate,
  Icon,
  List,
  Typography,
} from "@inductiveautomation/ws-components";

const ElectiveStudiesWidget = ({ courses }: { courses: Elective[] }) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "public_profile.sections.training.elective_studies",
  });

  return (
    <DashboardWidget
      icon="course"
      heading={t("heading")}
      subtitle={t("number_earned", { count: courses.length })}
      contentMaxHeight="262px"
      testId="elective-studies"
      headerActions={[
        {
          actions: [
            {
              id: "learn-more",
              buttonVariant: "tertiary",
              label: "Learn more",
              iconRight: "open-small",
              iconRightVariant: "neutralLight",
              onClick: () => undefined,
            },
          ],
        },
      ]}
    >
      <List
        onSelection={() => undefined}
        itemComponent={ComplexListItem}
        items={courses.map((course) => ({
          id: course.id,
          testId: course.id,
          avatar: course.icon ? (
            <Icon name={course.icon} />
          ) : (
            <Avatar icon={"course"} iconAvatarColor="empty" />
          ),
          heading: course.name,
          info: (
            <Typography variant="body2">
              {formatDate(course.completedAt, "date")}
            </Typography>
          ),
        }))}
      />
    </DashboardWidget>
  );
};

export default ElectiveStudiesWidget;
